import { render, staticRenderFns } from "./v-select-field.vue?vue&type=template&id=558420eb"
import script from "./v-select-field.vue?vue&type=script&lang=js"
export * from "./v-select-field.vue?vue&type=script&lang=js"
import style0 from "./v-select-field.vue?vue&type=style&index=0&id=558420eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports